import { render, staticRenderFns } from "./page-router.vue?vue&type=template&id=4540a93f&scoped=true"
import script from "./page-router.vue?vue&type=script&lang=js"
export * from "./page-router.vue?vue&type=script&lang=js"
import style0 from "./page-router.vue?vue&type=style&index=0&id=4540a93f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4540a93f",
  null
  
)

export default component.exports